export default async function storageInfo() {
  return Promise.race([getStorageInfo(), timeout()]);
}

async function getStorageInfo() {
  try {
    if (!navigator.storage) {
      return 0;
    }
    const estimation = await navigator.storage.estimate();

    return (estimation.quota || 0) - (estimation.usage || 0);
  } catch (e) {
    return null;
  }
}

// If `getStorageInfo` fails to return in two seconds, return null to indicate storage error
async function timeout() {
  return new Promise<null>((resolve) => {
    setTimeout(resolve, 2000, null);
  });
}
